/* ADD POLL */
export const EDIT_POLL_ANSWER = "EDIT_POLL_ANSWER"
export const EDIT_POLL_ANSWER_SUCCESS = "EDIT_POLL_ANSWER_SUCCESS"
export const EDIT_POLL_ANSWER_CLEAN = "EDIT_POLL_ANSWER_CLEAN"
export const EDIT_POLL_ANSWER_ERROR = "EDIT_POLL_ANSWER_ERROR"
